<template>
    <el-drawer
        title="确认处理"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="remark" label="对账处理备注:">
                    <el-input v-model="formData.remark" show-word-limit type="textarea" :rows="4" maxlength="100"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit()" :loading="btnLoading"
                >确 定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    data(){
        return{
            btnLoading:false,
            drawerShow:false,
            formData:{
                remark:'',
                sn: [],
                type: 0
            }
        }
    },
    methods:{
        close() {
            this.drawerShow = false;
        },
        show(sn,type){
            this.formData = {
                remark:'',
                sn: sn,
                type: type
            }
            this.drawerShow = true;
        },
        submit(){
            this.btnLoading = true;
            this.$request({
                url: "/finance/batchAbnormalDataList",
                method: "POST",
                data: {...this.formData},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success('处理成功');
                        this.$emit('onUpdate');
                        this.close();
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
    }
    
}
</script>